/// \file getUserInfo.ts
///
/// \par Copyright Notice:
/// Copyright (c) 2024 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import LocalDBCalls from "./localDBCalls";
import Redirect from "./redirect";

const getUserInfo = {
    getLevel: async function(navigate:any){
        const user_info = await LocalDBCalls.getUserInfo(document.cookie)
        if(user_info.user){
            return(user_info.user.level)
        }
        else{
            console.warn("LOGGED OUT from getLevel");
            Redirect("/auth/signin",navigate);
        }
        return("")
    },
    getCustomer: async function(navigate:any){
        const user_info = await LocalDBCalls.getUserInfo(document.cookie)
        if(user_info.user){
            return(user_info.user.customer_id)
        }
        else{
            console.warn("LOGGED OUT from getCustomer");
            Redirect("/auth/signin",navigate);
        }
        return("")
    },
    getAccessType: async function(navigate:any){
        const user_info = await LocalDBCalls.getUserInfo(document.cookie)
        if(user_info.user){
            return(user_info.user.userType)
        }
        else{
            console.warn("LOGGED OUT from getAccessType");
            Redirect("/auth/signin",navigate);
        }
        return("")
    },

}
export default getUserInfo;

